import { __decorate } from 'tslib';
import { ɵɵdefineInjectable, Injectable, EventEmitter, Input, Output, ViewChild, Component, NgModule } from '@angular/core';
import { Platform, IonicModule } from '@ionic/angular';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { CommonModule } from '@angular/common';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';

let UiCSwiperService = class UiCSwiperService {
    constructor() { }
};
UiCSwiperService.ngInjectableDef = ɵɵdefineInjectable({ factory: function UiCSwiperService_Factory() { return new UiCSwiperService(); }, token: UiCSwiperService, providedIn: "root" });
UiCSwiperService = __decorate([
    Injectable({
        providedIn: 'root'
    })
], UiCSwiperService);

let UiCSwiperComponent = class UiCSwiperComponent {
    constructor(platform) {
        this.platform = platform;
        this.doIonSlideNextEnd = new EventEmitter();
        this.doIonSlidePrevEnd = new EventEmitter();
        this.doIonSlideReachEnd = new EventEmitter();
        this.doIonSlideReachStart = new EventEmitter();
        this.options = [];
        this.dataSource = [];
    }
    slideNext() {
        this.slides.slideNext();
    }
    slidePrev() {
        this.slides.slidePrev();
    }
    ionSlideNextEnd() {
        this.doIonSlideNextEnd.emit();
    }
    ionSlidePrevEnd() {
        this.doIonSlidePrevEnd.emit();
        document.querySelector('ui-c-swiper').classList.remove('swiper-end-flow');
    }
    ionSlideReachEnd() {
        this.doIonSlideReachEnd.emit();
        document.querySelector('ui-c-swiper').classList.add('swiper-end-flow');
    }
    ionSlideReachStart() {
        this.doIonSlideReachStart.emit();
    }
    slideTo(index, speed) {
        this.slides.slideTo(index, speed);
    }
    isBeginning() {
        return this.slides.isBeginning();
    }
    isEnd() {
        return this.slides.isEnd();
    }
    length() {
        return this.slides.length();
    }
};
UiCSwiperComponent.ctorParameters = () => [
    { type: Platform }
];
__decorate([
    Input()
], UiCSwiperComponent.prototype, "options", void 0);
__decorate([
    Input()
], UiCSwiperComponent.prototype, "bullets", void 0);
__decorate([
    Input()
], UiCSwiperComponent.prototype, "dataSource", void 0);
__decorate([
    Input()
], UiCSwiperComponent.prototype, "mode", void 0);
__decorate([
    Output()
], UiCSwiperComponent.prototype, "doIonSlideNextEnd", void 0);
__decorate([
    Output()
], UiCSwiperComponent.prototype, "doIonSlidePrevEnd", void 0);
__decorate([
    Output()
], UiCSwiperComponent.prototype, "doIonSlideReachEnd", void 0);
__decorate([
    Output()
], UiCSwiperComponent.prototype, "doIonSlideReachStart", void 0);
__decorate([
    ViewChild('ionSlider', { static: false })
], UiCSwiperComponent.prototype, "slides", void 0);
UiCSwiperComponent = __decorate([
    Component({
        selector: 'ui-c-swiper',
        template: "<div class=\"ui-c-swiper\" [ngClass]=\"mode !== 'image' ? 'swiper-background-mode' : 'swiper-image-mode'\">\n  <div class=\"ui-c-swiper-inner vh100\">\n    <ion-slides\n      [pager]=\"bullets\"\n      [options]=\"options\"\n      (ionSlideNextEnd)=\"ionSlideNextEnd()\"\n      (ionSlidePrevEnd)=\"ionSlidePrevEnd()\"\n      (ionSlideReachEnd)=\"ionSlideReachEnd()\"\n      (ionSlideReachStart)=\"ionSlideReachStart()\"\n      #ionSlider\n    >\n      <ng-container *ngIf=\"mode !== 'image'\">\n        <ion-slide class=\"vh100\" *ngFor=\"let image of dataSource\" [style.background-image]=\"'url(' + image.path + ')'\">\n        </ion-slide>\n      </ng-container>\n\n      <ng-container *ngIf=\"mode !== 'background'\">\n        <ion-slide\n          *ngFor=\"let image of dataSource; let i = index\"\n          [ngClass]=\"image.upTitle && i == 2 ? 'finalSlide' : 'vh100'\"\n        >\n          <div class=\"slide\">\n            <svg-icon [stretch]=\"false\" [src]=\"image.path\"></svg-icon>\n            <ng-container *ngIf=\"!!image.title\">\n              <h2 class=\"title font-family-bold mt-3 m-0\">{{ image.title | wlpTranslate }}</h2>\n            </ng-container>\n            <ng-container *ngIf=\"!!image.caption\">\n              <p class=\"caption\">{{ image.caption | wlpTranslate }}</p>\n            </ng-container>\n            <ng-container *ngIf=\"!!image.caption\">\n              <p class=\"field\">{{ image.idField | wlpTranslate }}</p>\n              <p class=\"field\">{{ image.emailField | wlpTranslate }}</p>\n              <p class=\"field\">{{ image.phoneField | wlpTranslate }}</p>\n              <p class=\"field\">{{ image.evpField | wlpTranslate }}</p>\n            </ng-container>\n          </div>\n        </ion-slide>\n      </ng-container>\n    </ion-slides>\n  </div>\n</div>\n",
        styles: [""]
    })
], UiCSwiperComponent);

let UiCSwiperModule = class UiCSwiperModule {
};
UiCSwiperModule = __decorate([
    NgModule({
        declarations: [UiCSwiperComponent],
        imports: [IonicModule, UiBsTranslateModule, CommonModule, AngularSvgIconModule.forRoot()],
        exports: [UiCSwiperComponent],
    })
], UiCSwiperModule);

/*
 * Public API Surface of ui-c-swiper
 */

/**
 * Generated bundle index. Do not edit.
 */

export { UiCSwiperComponent, UiCSwiperModule, UiCSwiperService };
//# sourceMappingURL=wlp-ui-c-swiper.js.map
